import Vue from 'vue'
import 'vue2-animate/dist/vue2-animate.min.css';
import 'mint-ui/lib/style.css';
import App from './App'
import router from './router'
import axios from 'axios'
import axiosConfig from './service/config'
import MintUI from 'mint-ui';
import store from './store';
import CryptoJS from 'crypto-js/crypto-js'
import Swiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import ls from "./store/LStorage";
import { Indicator } from "mint-ui";
import svg from 'svg-progress-bar';
import { errorHandler } from "./service/errorHandler"
import BScroll from 'better-scroll';
import infiniteScroll from 'vue-infinite-scroll';
import userService from "./service/userService.js"
import docdefalute from './assets/img/docdefalute.jpg'
import saledefalute from './assets/img/saledefalute.jpg'
import userdefalute from './assets/img/userdefalute.jpg'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
Vue.use(MintUI)
Vue.use(infiniteScroll)
Vue.use(svg, { componentName: 'percent-bar' })
Vue.use(Swiper)
Vue.config.productionTip = false
Vue.prototype.$defaultUserImg = userdefalute;
Vue.prototype.$defaultSaleImg = saledefalute;
Vue.prototype.$defaultDocImg = docdefalute;
Vue.prototype.$defaultImg = saledefalute;
Vue.config.errorHandler = errorHandler
let now = new Date().getTime();
let signature = CryptoJS.MD5(`appkey=cce7d5f15068ed5f3911323c&timestamp=${now}&random_str=fdsafsf2313214jkjkl42j1klj32321kj4j321&key=37cd19f204e7c178b8bb3613`)

document.setTitle = function (t) {
  document.title = t;
  var i = document.createElement('iframe');
  i.src = '//m.baidu.com/favicon.ico';
  i.style.display = 'none';
  i.onload = function () {
    setTimeout(function () {
      i.remove();
    }, 9)
  }
  document.body.appendChild(i);
}
const agent = navigator.userAgent
const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
router.beforeEach((to, from, next) => {
      //测试版生产环境测试
  if (ENV_DEV) {
    document.title = '泉脉-测试版';
  } else {
    document.title = '泉脉';
  }
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS && to.path !== location.pathname) {
        location.assign(to.fullPath)
    } else {
        next()
    }
});
router.afterEach((to, from) => {
  if (to.path != '/contacts/reply') {
    window.scrollTo(0, 0)
  }
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js